import * as THREE from "three";

export class Webcam {
    obj;

    width = 120;
    height = 80;

    videoElem;

    canvas;
    ctx;

    constructor(videoElem) {
        this.videoElem = videoElem;
        this.width = videoElem.width;
        this.height = videoElem.height;

        this.canvas = new OffscreenCanvas(this.width, this.height);
        this.ctx = this.canvas.getContext('2d');

        // background color if no video present
        this.ctx.fillStyle = '#000000';
        this.ctx.fillRect(0, 0, this.width, this.height);
    }


    update() {
        if (this.videoElem.readyState === this.videoElem.HAVE_ENOUGH_DATA) {
            this.ctx.drawImage(this.videoElem, 0, 0, this.width, this.height);
            if (this.obj)
                this.obj.needsUpdate = true;
        }
    }

    add(parent) {
        this.obj = new THREE.Texture(this.canvas);
        this.obj.minFilter = THREE.LinearFilter;
        this.obj.magFilter = THREE.LinearFilter;

        const movieMaterial = new THREE.MeshBasicMaterial({map: this.obj, overdraw: true, side: THREE.DoubleSide});
        // the geometry on which the movie will be displayed;
        // 		movie image will be scaled to fit these dimensions.
        const movieGeometry = new THREE.PlaneGeometry(100, 100, 1, 1);
        const movieScreen = new THREE.Mesh(movieGeometry, movieMaterial);

        movieScreen.name = "webcam";

        parent.add(movieScreen)
    }

    playAnimation(key) {
        //
    }
}